import { useWidgetEvents } from '@ptek/widget-core';
import React, { useContext, useEffect, useRef } from 'react';
import { WIDGET_EVENTS } from '../constants/events';
import { AppContext } from '../context/AppContext';
import { useContextDataHandler, useHostTemplateHandler } from '../hooks/index';
import {
  EncounterData,
  useEncounterHandler,
} from '../hooks/useEncounterHandler';
import type { FormattedTemplate } from '../types/templates';
import { ContextData } from '../types/widget';
import { loadUserSettingsPreferences } from '../utils/userPreferences';

export const EventHandler: React.FC = () => {
  const { onHostEvent, emitToHost } = useWidgetEvents();
  const hasEmittedReady = useRef(false);
  const { user } = useContext(AppContext);

  const userId = user?.username || user?.email;
  const { handleSetEncounter } = useEncounterHandler();
  const { handleSetContextData } = useContextDataHandler(
    userId,
    loadUserSettingsPreferences
  );
  const { handleSetHostTemplates } = useHostTemplateHandler();

  useEffect(() => {
    const cleanupEncounter = onHostEvent(
      WIDGET_EVENTS.LISTENER_NAMES.SET_ENCOUNTER,
      (data) => {
        handleSetEncounter(data as EncounterData);
      }
    );

    const cleanupContextData = onHostEvent(
      WIDGET_EVENTS.LISTENER_NAMES.SET_CONTEXT_DATA,
      (data) => {
        handleSetContextData(data as ContextData);
      }
    );

    const cleanupTemplates = onHostEvent(
      WIDGET_EVENTS.LISTENER_NAMES.SET_TEMPLATES,
      (data) => {
        handleSetHostTemplates(
          data as {
            templates: FormattedTemplate[];
            autoSelectTemplateId?: string;
          }
        );
      }
    );

    if (!hasEmittedReady.current) {
      emitToHost(WIDGET_EVENTS.EMITTER_NAMES.READY);

      hasEmittedReady.current = true;
    }

    return () => {
      cleanupEncounter();
      cleanupContextData();
      cleanupTemplates();
    };
  }, [
    onHostEvent,
    handleSetEncounter,
    handleSetContextData,
    handleSetHostTemplates,
    emitToHost,
  ]);

  return null;
};
